import React from 'react';
import styled from '@emotion/styled';
import { useLocale } from 'locale';
import { useCountdown, formatCountdown } from 'hooks/useCountdown';
import { BasicButtonProps } from 'ds/components/button/BasicButton';
import { CustomButton } from '../CustomButton';
import PowerIcon from 'assets/svg/power.svg';

const StyledButton = styled(CustomButton)<{ isTimeLeft: boolean, withTimer: boolean }>(({ theme, isTimeLeft, withTimer }) => ({
  ...isTimeLeft ? {
    background: '#F4F4F4',
    color: withTimer ? theme.colors.neutrals.grey1 : theme.colors.brand.main,
    '> svg path': {
      stroke: '#606060',
    },
    [theme.media.createObjectMediaQuery({ at: 1 })]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(0.5),
      'svg': {
        marginLeft: 0,
      },
    },
  } : null,
}));

// Prevent countdown text jump around because of different digits width.
const CountdownSpan = styled.span(() => ({
  display: 'inline-block',
  minWidth: 58,
  textAlign: 'left',
}));

export interface ManualPromoteBulletinButtonProps {
  promotedUntil: Date;
  onClick: (event: React.MouseEvent, data: { timeLeft: number }) => void;
  mode?: BasicButtonProps['mode'];
  size?: BasicButtonProps['size'];
  className?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  withTimer?: boolean;
}

export const ManualPromoteBulletinButton = React.forwardRef<any, ManualPromoteBulletinButtonProps>((props, ref) => {
  const { promotedUntil, onClick, mode = 'primary', size, className, disabled, fullWidth, withTimer = false } = props;
  const { t } = useLocale();
  const timeLeft = useCountdown(promotedUntil);
  const isTimeLeft = withTimer ? timeLeft > 0 : false;

  const handleClick = (event: React.MouseEvent) => {
    onClick(event, { timeLeft });
  };

  return (
    <StyledButton
      ref={ref}
      onClick={handleClick}
      className={className}
      size={size}
      mode={isTimeLeft ? 'ghost' : mode}
      isTimeLeft={isTimeLeft}
      disabled={disabled}
      withTimer={withTimer}
      fullWidth={fullWidth}
    >
      {isTimeLeft ? (
        <>
          <PowerIcon width={20} height={24} />
          <CountdownSpan>{formatCountdown(timeLeft)}</CountdownSpan>
        </>
      ) : t('privateBulletinPromotion.manualPromoteButton')}
    </StyledButton>
  );
});
